import { render, staticRenderFns } from "./maximise-speed.vue?vue&type=template&id=b2acea6a&scoped=true"
import script from "./maximise-speed.vue?vue&type=script&lang=js"
export * from "./maximise-speed.vue?vue&type=script&lang=js"
import style0 from "./maximise-speed.vue?vue&type=style&index=0&id=b2acea6a&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2acea6a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/jenkins/data/workspace/KCC_AUDIT_PROD_Frontend/node_modules/vue-loader/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b2acea6a')) {
      api.createRecord('b2acea6a', component.options)
    } else {
      api.reload('b2acea6a', component.options)
    }
    module.hot.accept("./maximise-speed.vue?vue&type=template&id=b2acea6a&scoped=true", function () {
      api.rerender('b2acea6a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/client-view/home/maximise-speed.vue"
export default component.exports